export const hasErrors = (props = {}) => {
  const { errors } = props

  if (errors && errors instanceof Error) {
    return true
  }

  return Object.keys(errors || {}).length > 0
}



// WEBPACK FOOTER //
// ./src/io/error-handling/has-errors.js